import Fork from "../../../assets/images/forkIcon.svg";
import Paint from "../../../assets/images/paintIcon.svg";
import Other from "../../../assets/images/other.svg";

const cardCategories = {
  "Food & Drink": {
    categoryName: "food",
    image: Fork.toString(),
  },
  Culture: {
    categoryName: "culture",
    image: Paint.toString(),
  },
  Other: {
    categoryName: "other",
    image: Other.toString(),
  },
};
export default cardCategories;
